import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { ASSET_POLL_INTERVAL_MS } from '@/hooks/useDataPolling/pollingConstants';

export const ASSET_STATE_COUNTS_QUERY_KEY = 'assetStateCounts';

export function useGetAssetStateCounts({
  folders,
  pollWhileIndexing,
}: {
  folders?: string[];
  pollWhileIndexing?: boolean;
}) {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const foldersParameter = folders && folders.length > 0 ? folders?.join(',') : undefined;

  return useQuery({
    queryKey: [ASSET_STATE_COUNTS_QUERY_KEY, { tenantId, folders }],
    queryFn: async () => api.assets.getAssetStateCounts({ tenantId, folders: foldersParameter }),
    select: data => data.data,
    enabled: !!tenantId,
    placeholderData: previousData => previousData,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    refetchInterval: pollWhileIndexing
      ? query => ((query.state.data?.data.indexing ?? 0) > 0 ? ASSET_POLL_INTERVAL_MS : false)
      : false,
  });
}
